import config from "config"

const getToken = () => sessionStorage.getItem("token") || localStorage.getItem("token")

const buildHeaders = () => ({
  "Content-type": "application/json",
  Authorization: `Bearer ${getToken()}`,
})

export const fetchNotifications = async (page = 0, size = 20) => {
  const url = `${config.api.baseURL}/notifications?page=${page}&size=${size}`
  const res = await fetch(url, { method: "GET", headers: buildHeaders() })
  if (!res.ok) throw new Error("Error al obtener notificaciones")
  return res.json()
}

export const fetchUnreadCount = async () => {
  const url = `${config.api.baseURL}/notifications/unread-count`
  const res = await fetch(url, { method: "GET", headers: buildHeaders() })
  if (!res.ok) throw new Error("Error al obtener el contador de notificaciones")
  const data = await res.json()
  return data?.count ?? 0
}

export const markNotificationRead = async (id) => {
  const url = `${config.api.baseURL}/notifications/${id}/read`
  const res = await fetch(url, { method: "PUT", headers: buildHeaders() })
  return res.ok
}

export const markAllNotificationsRead = async () => {
  const url = `${config.api.baseURL}/notifications/read-all`
  const res = await fetch(url, { method: "PUT", headers: buildHeaders() })
  if (!res.ok) throw new Error("Error al marcar todas como leídas")
  const data = await res.json()
  return data?.updated ?? 0
}
